export const  toggleDarkModeAction=(a)=>{
    return{
        type:"changeDarkModeToggle",
        value:a
    }
}